import { Constants } from 'src/shared/utilities/constants.util';

class Channels {
    ['AUTHENTICATION:USER'] =           'app://found/authentication/user';  // an AUO (Active User Object)
}

export { Channels };
